module.exports = __webpack_public_path__ + "img/calendar-days-regular 1.71312e0d.svg";